
const PPEDetailsPage = () => import('frontend/pages/settings/PPEDetailsPage')
const PPEManagementPage = () => import('frontend/pages/settings/PPEManagementPage')

import { PPE_TYPES } from 'frontcore/constants/ppe'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: 'ppe-management',
    name: SETTINGS_CARDS_TOKENS.ppeConfiguration.name,
    component: PPEManagementPage,
    props: { source: 'ppe', type: PPE_TYPES.ppe, title: 'settings.messages.ppe_list' },
  },
  {
    path: 'ppe-details/:id?',
    name: 'ppe-details',
    component: PPEDetailsPage,
    props: { type: PPE_TYPES.ppe },
  },
  {
    path: 'tool-management',
    name: SETTINGS_CARDS_TOKENS.toolConfiguration.name,
    component: PPEManagementPage,
    props: { source: 'ppe', type: PPE_TYPES.tool, title: 'settings.messages.tool_list' },
  },
  {
    path: 'tool-details/:id?',
    name: 'tool-details',
    component: PPEDetailsPage,
    props: { type: PPE_TYPES.tool },
  },
]
